// Four-category QC findings for AdDetailModal. No status, no phase —
// the modal decides whether to mount this from shouldPaintQcOutline.

import { Box, HStack, Text } from '@chakra-ui/react';
import {
  PASS_FLOOR,
  QC_CATEGORY_LABELS,
  QC_CATEGORY_ORDER,
  type QcVisionSummary
} from '../../lib/qcAdvisoryOutline';

export function QcFindingsPanel({
  visionQc,
  failure
}: {
  visionQc?: QcVisionSummary | null;
  failure?: { label: string; isQc: boolean } | null;
}) {
  const title = failure?.label || 'Vision QC';
  const categories = visionQc?.categories;
  return (
    <Box mt={2} mb={3} p={3} borderWidth="1px" borderColor="red.300" bg="red.50" borderRadius="md">
      <Text fontSize="sm" fontWeight="700" color="red.700">
        {title}
      </Text>
      {visionQc?.summary && (
        <Text fontSize="sm" color="brand.ink" mt={1}>
          {visionQc.summary}
        </Text>
      )}
      {visionQc?.failureDetail && (
        <Text
          fontSize="11px"
          color="brand.muted"
          mt={2}
          whiteSpace="pre-wrap"
          fontFamily="mono"
        >
          {visionQc.failureDetail}
        </Text>
      )}
      {categories && (
        <Box mt={3}>
          {QC_CATEGORY_ORDER.map((key) => {
            const cat = categories[key];
            const pass = cat?.pass === true;
            const score = cat?.score;
            const labelTint = cat ? (pass ? 'green.700' : 'red.700') : 'brand.muted';
            const scoreTint = typeof score === 'number'
              ? (score >= PASS_FLOOR ? 'green.700' : 'red.700')
              : 'brand.muted';
            const findings = Array.isArray(cat?.findings) ? cat.findings.slice(0, 3) : [];
            return (
              <Box key={key} mt={2}>
                <HStack justify="space-between" spacing={2} align="baseline">
                  <Text fontSize="11px" fontWeight="700" color={labelTint}>
                    {QC_CATEGORY_LABELS[key]}
                  </Text>
                  <Text fontSize="11px" fontWeight="700" color={scoreTint} fontFamily="mono">
                    {typeof score === 'number' ? `${score}/10` : '—'}
                    {cat ? (pass ? ' · pass' : ' · fail') : ''}
                  </Text>
                </HStack>
                {findings.map((f, i) => (
                  <Text key={i} fontSize="11px" color="brand.muted" mt={0.5}>
                    {f}
                  </Text>
                ))}
                {cat?.caveat && (
                  <Text fontSize="11px" color="brand.muted" mt={1} fontStyle="italic">
                    {cat.caveat}
                  </Text>
                )}
              </Box>
            );
          })}
        </Box>
      )}
      <Text fontSize="11px" color="brand.muted" mt={3}>
        This ad is a draft, not discarded. Approve and Export still work —
        publishing is how you disagree with this verdict.
      </Text>
    </Box>
  );
}
